export const DataConf = {
    initialState: {
      loading: false,
      error: null,
      data: [],
      meta: null,
    },
  };